module.exports = __webpack_public_path__ + "static/media/nutrient-no-pic.2d40097c.png";